import React from 'react';
import DynamicForm from './DynamicForm';
import './EditElevatorModal.css';

function EditElevatorModal({
    isOpen,
    onClose,
    fields,
    initialData,
    onSubmit,
    isEditing
}) {
    const [formData, setFormData] = React.useState(initialData || {});

    React.useEffect(() => {
        setFormData(initialData || {});
    }, [initialData, isOpen]);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal-overlay" role="dialog" aria-modal="true">
            <div className="modal-content app-panel app-panel--strong">
                <div className="modal-header">
                    <div>
                        <span className="app-eyebrow">{isEditing ? '编辑资料' : '新增资料'}</span>
                        <h3>{isEditing ? `编辑电梯 ${initialData?.id}` : '新增电梯记录'}</h3>
                        <p>表单字段按后台配置自动生成，提交后会直接调用现有后端接口。</p>
                    </div>
                    <button type="button" className="app-button app-button--secondary app-button--small" onClick={onClose}>
                        关闭
                    </button>
                </div>

                <div className="modal-body">
                    <DynamicForm
                        fields={fields}
                        formData={formData}
                        onChange={setFormData}
                        onSubmit={onSubmit}
                        submitLabel={isEditing ? '保存修改' : '确认新增'}
                        readOnlyFields={isEditing ? ['id'] : []}
                    />
                </div>
            </div>
        </div>
    );
}

export default EditElevatorModal;
